import {Helper, RadioGroupControl} from '../../../app/shared/classes';
import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums';

import {ClientTypesEnum} from '../../../app/entries/panel/enums';

export const ClientsAddClientTypeSelector = 'clientType';

export const ClientsAddClientTypeControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: ClientsAddClientTypeSelector,
        value: ClientTypesEnum.Individual,
        placeholder: 'Client Type',
        validators: [],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: [
            {
                label: Helper.textsHelper().getClientTypeName(ClientTypesEnum.Individual),
                value: ClientTypesEnum.Individual,
                color: ColorCodesEnum.Primary,
                checked: true
            },
            {
                label: Helper.textsHelper().getClientTypeName(ClientTypesEnum.Corporate),
                value: ClientTypesEnum.Corporate,
                color: ColorCodesEnum.Primary
            }
        ]
    });
};
